import {rawRenderingLib, RenderingServices} from '@wallaby-ui/core';
import {ICellRendererParams} from 'ag-grid-community';

import styles from 'src/js/common/components/formatters/IconSpanWrapperLinkFormatter.less';
import stylesLinkFormatter from 'src/js/common/components/formatters/LinkFormatter.less';
import {basePatientListLinkFormatterParams} from 'src/js/lib/raw_rendering/base_patient_list_link_formatter_params';

/**
 * Returns raw DOM element version of EncounterLinkFormatter component.
 * @param params
 * @param services
 * @returns {Element}
 */
export function hospitalizationsListLinkFormatter(
  params: ICellRendererParams,
  services: RenderingServices
) {
  const {id, label, titleText} = basePatientListLinkFormatterParams(
    params,
    services
  );

  const spanElem = document.createElement('span');
  spanElem.className = styles.dlSpanWrapper;

  const divElem = document.createElement('div');
  // TODO-JK: refactor when redirect links are added
  divElem.className = stylesLinkFormatter.dlHospitalizationsLinkFormatter;

  const textElem = rawRenderingLib.plainTextOrHtmlRenderer({
    showHtml: true,
    text: label,
    className: stylesLinkFormatter.dlLinkFormatterText,
  });

  // TODO-JK: uncomment and restyle when working on Hospitalizations detail
  // const linkElem = entityLinkRenderer(
  //   {
  //     id,
  //     route: ROUTE_HOSPITALIZATIONS,
  //     titleText,
  //     suppressPadding: true,
  //     children: textElem,
  //   },
  //   services
  // );
  // rawRenderingLib.RawRenderingService.appendChildNodeOrHtml(divElem, linkElem);

  rawRenderingLib.RawRenderingService.appendChildNodeOrHtml(divElem, textElem);

  rawRenderingLib.RawRenderingService.appendChildNodeOrHtml(spanElem, divElem);

  return spanElem;
}
